import React from 'react';

function LoadingSpinner() {
    return (
        <div className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin" />
    );
}

export default LoadingSpinner;
